import { Building2 } from 'lucide-react';

const MenuConfigurationBranchEmpty = () => (
  <div className="flex min-h-[340px] flex-col items-center justify-center px-6 text-center">
    <span className="rounded-xl border border-stroke bg-gray-2 p-4 text-bodydark2 dark:border-strokedark dark:bg-meta-4">
      <Building2 className="h-8 w-8" />
    </span>
    <h2 className="mt-4 text-lg font-semibold text-black dark:text-white">
      No hay sucursales disponibles
    </h2>
    <p className="mt-1 max-w-md text-sm text-bodydark2">
      Configure una sucursal antes de administrar modificadores y combos.
    </p>
  </div>
);

export default MenuConfigurationBranchEmpty;
